import React, { useEffect, useState, useRef } from 'react';
import Header from '../../Header';
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext';

import api from '../../../services/api';
import apiUploads from '../../../services/apiUploads';
import { fileApiUrl } from '../../../config/apiConfig';

import { MdOutlineFilterList, MdGroups, MdOutlineSearch, MdOutlineUpdate, MdAdd, MdDelete } from "react-icons/md";
import { MdPerson, MdPhone, MdAttachMoney, MdDescription, MdLocalShipping, MdLocationCity, MdLabel, MdPublic, MdPictureAsPdf, MdFileDownload } from 'react-icons/md';

import logoDefault from '../../../assets/logo-suite-flow.ico'

import logoPrefweb from '../../../assets/logo-prefweb.PNG'

import logoInstalacao from '../../../assets/logo-instalacao.PNG'
import logoMontagem from '../../../assets/logo-montagem.PNG'

import { useNavigate } from 'react-router-dom';

import './style.css';

function PortalPage() {
  const { user, empresa } = useUser();

  const [conteudoSelecionado, setConteudoSelecionado] = useState(null);
  const [topicoSelecionado, setTopicoSelecionado] = useState(null);

  const [showAddVideoModal, setShowAddVideoModal] = useState(false);
  const [newVideoDescription, setNewVideoDescription] = useState('');
  const [newVideoLink, setNewVideoLink] = useState('');
  const [addingVideo, setAddingVideo] = useState(false);

  const [selectedVideo, setSelectedVideo] = useState(null);

  const [materiais, setMateriais] = useState([]);
  const fileInputRef = useRef(null);

  const [conteudo, setConteudo] = useState([
    { id: 1, logo: logoPrefweb, description: 'PrefWeb' },
    { id: 2, logo: '', description: 'SyncsCRM' },
    { id: 3, logo: logoInstalacao, description: 'Instalação' },
    { id: 4, logo: logoMontagem, description: 'Produção' },
  ]);

  const [topicos, setTopicos] = useState([
    { id: 1, conteudo_id: 1, description: 'PrefWeb' },
    { id: 2, conteudo_id: 2, description: 'SyncsCRM' },
    { id: 3, conteudo_id: 3, description: 'Instalação' },
    { id: 4, conteudo_id: 4, description: 'Produção' },
  ]);

  const [midia, setMidia] = useState([
    // { id: 1, topico_id: 1, description: 'Tutorial - Portas em cantos livre com n° de trilhos diferente | Orçamentos + PrefWeb #1', link: 'https://youtu.be/bD8FUwDT9-M?si=3XvWgVw9wcQDmIkm' },
    // { id: 2, topico_id: 1, description: 'Tutorial - Edição múltipla do orçamento no Web | Orçamentos + PrefWeb #2', link: 'https://youtu.be/pozPmfYyDwk' },
    // { id: 3, topico_id: 1, description: 'Tutorial - Como orçar uma janela BayWindow (Parte 1) | Orçamentos + PrefWeb #3', link: 'https://youtu.be/TqbBtFi_cBQ?si=UwkXVMggU1gh46Vb' },
    // { id: 4, topico_id: 1, description: 'Tutorial - Como orçar uma janela BayWindow (Parte 2) | Orçamentos + PrefWeb #3', link: 'https://youtu.be/vzmGmyx6s9M?si=Tn6FDU1A3t7_o5Ow' },
    // { id: 5, topico_id: 2, description: 'Tutorial - Implantação de pedidos | Orçamentos + SyncsCRM #1', link: 'https://youtu.be/Xiq5S8dn-4s?si=R1Sny4V-LLj8VHHJ' },
    // { id: 6, topico_id: 2, description: 'Tutorial - Diferença entre colunas "Ajuste" e "Alteração" | Orçamentos + SyncsCRM #2', link: 'https://youtu.be/TIQwZWysJWE?si=RezSz7bb2fyLbfHy' },
    // { id: 7, topico_id: 2, description: 'Tutorial - Como alterar um pedido no CRM | Orçamentos + SyncsCRM #3', link: 'https://youtu.be/6oBlAYYhVMs?si=66A9Eric0MM6Uhg4' },
    // { id: 8, topico_id: 2, description: 'Tutorial - Como unificar os arquivos do checklist em um único PDF | Orçamentos + CRM #4', link: 'https://youtu.be/FfjhkUCdSSQ?si=YWQ_irWd_iOrQS1t' },
    // { id: 9, topico_id: 2, description: 'Tutorial - Como salvar os dados de um formulário localmente | Orçamentos + CRM #5', link: 'https://youtu.be/ZecaQnxpCCE?si=Gc0YWX0bfekyY2Uv' },
    // { id: 10, topico_id: 2, description: 'Tutorial - Como ativar uma nova versão de formulário no CRM | Orçamentos + CRM #6', link: 'https://youtu.be/BizAdCKn7xY?si=Yous3R54h8ljLmpC' },
    // { id: 11, topico_id: 2, description: 'Tutorial - Como preencher a planilha de valores do formulário de pedidos | Orçamentos + CRM #7', link: 'https://youtu.be/zTTEbK0024U?si=O9ddgi8rF_MtAirb' },
    // { id: 12, topico_id: 2, description: 'Tutorial - Entendendo cada coluna do CRM | Orçamentos + CRM #8', link: 'https://youtu.be/jtulgAC4KNo?si=PU3HPVOeAQgBVq19' },
  ]);

  // Função para buscar vídeos da tabela
  const fetchVideos = async () => {
    try {
      const response = await api.get('/users/portal/videos');
      const videosFromDB = response.data;
      
      // Combinar vídeos do banco com os vídeos existentes
      // Usando um Map para evitar duplicatas baseado no link
      const videoMap = new Map();
      
      // Primeiro adiciona os vídeos existentes
      midia.forEach(video => {
        videoMap.set(video.link, video);
      });
      
      // Depois adiciona os vídeos do banco
      videosFromDB.forEach(video => {
        videoMap.set(video.link, video);
      });
      
      // Converte o Map de volta para array
      const combinedVideos = Array.from(videoMap.values());
      setMidia(combinedVideos);
    } catch (error) {
      console.error('Erro ao buscar vídeos:', error);
    }
  };

  // Buscar vídeos quando o componente montar ou quando o conteúdo selecionado mudar
  useEffect(() => {
    fetchVideos();
  }, [conteudoSelecionado]);

  const handleConteudoClick = (id) => {
    setConteudoSelecionado(id);
    setTopicoSelecionado(null);
  };

  const handleTopicoClick = (id) => {
    setTopicoSelecionado(id);
  };

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  const getYouTubeID = (url) => {
    const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  };

  const handleDeleteVideo = async (videoId) => {
    if (window.confirm('Tem certeza que deseja excluir este vídeo?')) {
      try {
        await api.delete(`/users/portal/video/${videoId}`);
        setMidia(midia.filter(m => m.id !== videoId));
      } catch (error) {
        console.error('Erro ao excluir vídeo:', error);
        alert('Erro ao excluir vídeo. Por favor, tente novamente.');
      }
    }
  };

  const handleAddVideo = () => {
    setNewVideoDescription('');
    setNewVideoLink('');
    setShowAddVideoModal(true);
  };

  const handleSubmitVideo = async () => {
    if (!newVideoDescription.trim()) { alert('Informe a descrição do vídeo.'); return; }
    if (!newVideoLink.trim()) { alert('Informe o link do vídeo.'); return; }
    setAddingVideo(true);
    try {
      const response = await api.post('/users/portal/video', {
        topico_id: topicoSelecionado,
        description: newVideoDescription.trim(),
        link: newVideoLink.trim(),
      });
      const newVideo = response.data.video;
      setMidia([...midia, newVideo]);
      setShowAddVideoModal(false);
    } catch (error) {
      console.error('Erro ao adicionar vídeo:', error);
      alert('Erro ao adicionar vídeo. Por favor, tente novamente.');
    } finally {
      setAddingVideo(false);
    }
  };

  const fetchMateriais = async (topicoId) => {
    try {
      const response = await apiUploads.get(`/portal-materiais/list/${topicoId}`);
      setMateriais(response.data);
    } catch (error) {
      console.error('Erro ao buscar materiais:', error);
      setMateriais([]);
    }
  };

  const handleUploadMaterial = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      await apiUploads.post(`/portal-materiais/${topicoSelecionado}`, formData);
      fetchMateriais(topicoSelecionado);
    } catch (error) {
      console.error('Erro ao enviar material:', error);
      const errMessage = error.response?.data?.message || 'Erro ao enviar material. Por favor, tente novamente.';
      alert(errMessage);
    }

    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleDeleteMaterial = async (fileName) => {
    if (!window.confirm('Tem certeza que deseja excluir este material?')) return;

    try {
      await apiUploads.delete(`/portal-materiais/${topicoSelecionado}/${fileName}`);
      fetchMateriais(topicoSelecionado);
    } catch (error) {
      console.error('Erro ao excluir material:', error);
      alert('Erro ao excluir material. Por favor, tente novamente.');
    }
  };

  useEffect(() => {
    if (topicoSelecionado) {
      fetchMateriais(topicoSelecionado);
    } else {
      setMateriais([]);
    }
  }, [topicoSelecionado]);

  return (
    <div className='portal-page-container'>
      <Header />
      <div className='body-portal-container'>
        <div className='list-conteudo-principal'>
          {conteudo.map((item) => (
            <div
              key={item.id}
              className='item-list-conteudo-principal'
              onClick={() => handleConteudoClick(item.id)}
            >
              <div className='content-header'>
                <img
                  src={item.logo || logoDefault}
                  alt={`${item.description} logo`}
                  className='item-logo'
                />
              </div>
              <div className='content-description'>
                <h4>{item.description}</h4>
              </div>
            </div>
          ))}
        </div>

        {conteudoSelecionado && (
          <div className='list-topicos'>
            <h3>Tópicos</h3>
            <div className='list-midia-container'>
              {topicos
                .filter((topico) => topico.conteudo_id === conteudoSelecionado)
                .map((topico) => (
                  <div
                    key={topico.id}
                    className='item-list-topico'
                    onClick={() => handleTopicoClick(topico.id)}
                  >
                    {topico.description}
                  </div>
                ))}
            </div>
          </div>
        )}
        {topicoSelecionado && (
          <div className='list-midia'>
            <div className='list-midia-header'>
              <h3>Mídias</h3>
              {[5, 8, 9].includes(Number(user?.access_level)) && (
                <button 
                  className='add-video-button'
                  onClick={handleAddVideo}
                >
                  <MdAdd /> Adicionar Vídeo
                </button>
              )}
            </div>
            <div className='list-midia-container'>
              {midia
                .filter((m) => m.topico_id === topicoSelecionado)
                .map((m) => (
                  <div
                    key={m.id}
                    className='item-list-midia'
                  >
                    <div 
                      className='video-content'
                      onClick={() => handleVideoClick(m)}
                    >
                      <img
                        src={`https://img.youtube.com/vi/${getYouTubeID(m.link)}/hqdefault.jpg`}
                        alt={m.description}
                        className='video-thumbnail'
                      />
                      <p className='midia-description'>{m.description}</p>
                    </div>
                    {[5, 8, 9].includes(Number(user?.access_level)) && (
                      <button 
                        className='delete-video-button'
                        onClick={() => handleDeleteVideo(m.id)}
                      >
                        <MdDelete />
                      </button>
                    )}
                  </div>
                ))}
            </div>
          </div>
        )}

        {topicoSelecionado && (
          <div className='list-materiais'>
            <div className='list-midia-header'>
              <h3>Materiais (PDF)</h3>
              {[5, 8, 9].includes(Number(user?.access_level)) && (
                <>
                  <input
                    type='file'
                    accept='.pdf'
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleUploadMaterial}
                  />
                  <button
                    className='add-video-button'
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <MdAdd /> Adicionar PDF
                  </button>
                </>
              )}
            </div>
            <div className='list-materiais-container'>
              {materiais.length === 0 && (
                <p className='no-materiais-text'>Nenhum material disponível para este tópico.</p>
              )}
              {materiais.map((mat) => (
                <div key={mat.fileName} className='item-list-material'>
                  <div
                    className='material-content'
                    onClick={() => window.open(`${fileApiUrl}/portal-materiais/download/${topicoSelecionado}/${mat.fileName}`, '_blank')}
                  >
                    <MdPictureAsPdf className='material-icon' />
                    <p className='material-name'>{mat.originalName}</p>
                  </div>
                  {[5, 8, 9].includes(Number(user?.access_level)) && (
                    <button
                      className='delete-video-button'
                      onClick={() => handleDeleteMaterial(mat.fileName)}
                    >
                      <MdDelete />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {showAddVideoModal && (
          <div className='modal-portal'>
            <div className='modal-add-video-content'>
              <h3>Adicionar Vídeo</h3>
              <label>Descrição do vídeo</label>
              <input
                type='text'
                className='modal-add-video-input'
                placeholder='Ex: Tutorial - Como orçar uma janela...'
                value={newVideoDescription}
                onChange={(e) => setNewVideoDescription(e.target.value)}
              />
              <label>Link do YouTube</label>
              <input
                type='text'
                className='modal-add-video-input'
                placeholder='https://youtu.be/...'
                value={newVideoLink}
                onChange={(e) => setNewVideoLink(e.target.value)}
              />
              <div className='modal-add-video-actions'>
                <button className='modal-cancel-btn' onClick={() => setShowAddVideoModal(false)} disabled={addingVideo}>
                  Cancelar
                </button>
                <button className='modal-confirm-btn' onClick={handleSubmitVideo} disabled={addingVideo}>
                  {addingVideo ? 'Salvando...' : 'Adicionar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {selectedVideo && (
          <div className='modal-portal'>
            <div className='modal-content-portal'>
              <button className='close-button-portal' onClick={closeModal}>
                Fechar
              </button>
              <iframe
                src={`https://www.youtube.com/embed/${getYouTubeID(selectedVideo.link)}`}
                title={selectedVideo.description}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              <p>{selectedVideo.description}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PortalPage;
